import { AuthenticationDetails, CognitoUser, CognitoUserSession, CognitoUserPool, IAuthenticationDetailsData, CognitoRefreshToken } from "amazon-cognito-identity-js";
import { IAwsConfig } from "../models/aws";
import { IRefreshToken } from "src/modules/Auth/store/types";

export class CognitoLoginService {
    private userPool: CognitoUserPool;

    constructor(
        private awsConfig: IAwsConfig,
    ) {
        this.userPool = new CognitoUserPool({
            UserPoolId: this.awsConfig.userPoolId,
            ClientId: this.awsConfig.clientId
        });
    }

    public login(login: string, password: string): Promise<CognitoUserSession> {
        const authenticationDetails = new AuthenticationDetails(this.getAuthDetails(login, password));
        const cognitoUser = new CognitoUser(this.getUserData(login));

        cognitoUser.setAuthenticationFlowType('USER_PASSWORD_AUTH');
        return new Promise<CognitoUserSession>((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: result => {
                    resolve(result);
                },
                onFailure: err => {
                    reject(err);
                }
            });
        });
    }

    public refreshLoginSession(email: string, { token }: IRefreshToken): Promise<any> {
        const cognitoUser = new CognitoUser(this.getUserData(email));
        const cognitoRefreshToken = new CognitoRefreshToken({ RefreshToken: token });
        return new Promise<any>((resolve, reject) => {
            cognitoUser.refreshSession(cognitoRefreshToken, (error, result) => {
                if (error) reject(error);
                else {
                    resolve(result);
                }
            });
        });
    }

    public changePassword(login: string, currentPass: string, newPass: string): Promise<any> {
        const authenticationDetails = new AuthenticationDetails(this.getAuthDetails(login, currentPass));
        const cognitoUser = new CognitoUser(this.getUserData(login));

        cognitoUser.setAuthenticationFlowType('USER_PASSWORD_AUTH');
        return new Promise<any>((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: () => {
                    cognitoUser.changePassword(currentPass, newPass, (error, result) => {
                        if (error) reject(error);
                        else {
                            resolve(result);
                        }
                    });
                },
                onFailure: err => {
                    reject(err);
                }
            })
        });
    }

    public forgotPassword(login: string): Promise<any> {
        const cognitoUser = new CognitoUser(this.getUserData(login));
        return new Promise<any>((resolve, reject) => {
            cognitoUser.forgotPassword({
                onSuccess: (result) => {
                    resolve(result);
                },
                onFailure: (error) => {
                    reject(error);
                },
                inputVerificationCode() {
                    resolve({
                        successful: true
                    });
                }
            })
        });
    }

    public confirmPassword(login: string, newPassword: string, verificationCode: string): Promise<any> {
        const cognitoUser = new CognitoUser(this.getUserData(login));
        return new Promise<any>((resolve, reject) => {
            cognitoUser.confirmPassword(verificationCode, newPassword, {
                onSuccess: () => {
                    resolve({
                        successful: true
                    });
                },
                onFailure: (error) => {
                    reject(error);
                }
            });
        });
    }

    private getUserData(email: string) {
        return {
            Username: email,
            Pool: this.userPool
        };
    }

    private getAuthDetails(email: string, password: string): IAuthenticationDetailsData {
        return {
            Username: email,
            Password: password,
        };
    }
}



// WEBPACK FOOTER //
// ./src/share/services/cognito-login.ts